import React from "react"
import {Backdrop} from "@mui/material"
import {Container} from "./component"
import {MODAL_TIMEOUT} from "../../config/constants"
import {handlePropagation} from "../../utils/handlePropagation"
import connect from "./connect"

export type ModalProps = {
    open: boolean
    handleClose: () => void
    children: JSX.Element
    hideBackdrop?: boolean
    mobileHeight: number
    desktopHeight: number
}
const innerModalDefaultProps = {
    disableRestoreFocus: true,
    disableAutoFocus: true,
    disableEnforceFocus: true,
    disablePortal: true,
    keepMounted: false,
    disableScrollLock: true,
}

export const Modal = ({open, handleClose, children, hideBackdrop = false, mobileHeight, desktopHeight}: ModalProps) => (
    <Container
        {...innerModalDefaultProps}
        data-testid="modal"
        open={open}
        onClose={handleClose}
        onClick={handlePropagation}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{timeout: MODAL_TIMEOUT}}
        hideBackdrop={hideBackdrop}
        mobileHeight={mobileHeight}
        desktopHeight={desktopHeight}
    >
        {children}
    </Container>
)

export default connect(Modal)
